import PropTypes from 'prop-types'
import React from 'react'
import Article from '../templates/Article'

const EME6609LessonPlanPage = props => (
  <Article pathName={props.location.pathname} pageTitle="Lesson Plan">
    <section
      aria-labelledby="section-needs-assessment"
      css={css`
        padding-bottom: 5rem;
      `}
    >
      <div className="contain">
        <h1 id="section-needs-assessment">Lesson Plan</h1>
        <p>
          I used the lesson plan assignment as a chance to formalize a lot of
          information I had been gathering throughout the term in preparation
          for the final ID project deliverable.
        </p>
        <p>
          Since my plan for the final project deliverable was a functioning, web
          based training module, I chose to develop my lesson plan in a
          storyboard format, which provided me the opportunity to flesh out all
          of the text and media, as well as the overall module structure for the
          project. Having this asset was a huge help during the development of
          the final project deliverable.
        </p>
        <p>
          <a
            href="http://cdn.philsinatra.com/ufl/eme6609/Lesson_Plan.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Lesson Plan File
          </a>
        </p>
      </div>
    </section>
  </Article>
)

EME6609LessonPlanPage.propTypes = {
  location: PropTypes.object,
}

export default EME6609LessonPlanPage
